var dictionary = {
    messages: {
        decimal: function (e, i) {
            void 0 === i && (i = []);
            var n = i[0];
            return void 0 === n && (n = "*"), "The field must be numeric and may contain " + ("*" === n ? "" : n) + " decimal points."
        },
        max: function (e, i) {
            return e + " ne smije biti veći od " + i[0] + " znakova."
        },
        max_value: function (e, i) {
            return "Enter the amount below " + i[0] + "."
        },
        min_value: function () {
            return "The input value must be greater than 0."
        },
        numeric: function (e) {
            return e + " it can only contain numeric characters"
        },
        required: function (e) {
            return "Required input field!"
        }
    },
    attributes: {}
};

export {
    dictionary
};